import { render } from "./SpecialButton.vue?vue&type=template&id=d17dbf16&scoped=true"
const script = {}

import "./SpecialButton.vue?vue&type=style&index=0&id=d17dbf16&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d17dbf16"]])

export default __exports__